import { Translations } from './translation-interface';
import { appTranslationsEN } from '../../i18n';
import { loginTranslationsEN } from '../../pages/anonymous/Login/i18n';
import { assessmentResultTranslationsEN } from '../../pages/shared/AssessmentResult/i18n';
import { assessmentTranslationsEN } from '../../pages/shared/assessments/i18n';
import { patientAssessmentCardTranslationsEN } from '../../global_elements/Layouts/Cards/PatientAssessmentCard/i18n';
import { patientDashboardTranslationsEN } from '../../pages/patient/PatientDashboard/i18n';
import { resourcesTranslationsEN } from '../../pages/patient/PatientResources/i18n';
import { helpTranslationsEN } from '../../pages/shared/Help/i18n';
import { daisyChainTranslationsEN } from '../../pages/shared/DaisyChainAssessments/i18n';
import { patientConsentTranslationsEN } from '../../pages/patient/PatientConsent/i18n';
import { patientAccountTranslationsEN } from '../../pages/patient/PatientAccount/i18n';
import { accountDeleteConfirmTranslationsEN } from '../../pages/anonymous/AccountDeleteConfirm/i18n';
import { assessmentVerifyTranslationsEN } from '../../pages/anonymous/Assessment/AssessmentVerify.i18n';
import { datePickerTranslationsEN } from '../../global_elements/Inputs/LabeledDatePickerInput/i18n';
import { assessmentFormTranslationsEN } from '../../pages/anonymous/Assessment/AssessmentForm.i18n';
import { anonymousAssessmentTranslationsEN } from '../../pages/anonymous/Assessment/index.i18n';

export const en: Translations = {
  app: appTranslationsEN,
  login: loginTranslationsEN,
  assessmentResult: assessmentResultTranslationsEN,
  assessment: assessmentTranslationsEN,
  patientAssessmentCard: patientAssessmentCardTranslationsEN,
  patientDashboard: patientDashboardTranslationsEN,
  resources: resourcesTranslationsEN,
  help: helpTranslationsEN,
  daisyChain: daisyChainTranslationsEN,
  patientConsent: patientConsentTranslationsEN,
  patientAccount: patientAccountTranslationsEN,
  accountDeleteConfirm: accountDeleteConfirmTranslationsEN,
  assessmentVerify: assessmentVerifyTranslationsEN,
  datePicker: datePickerTranslationsEN,
  assessmentForm: assessmentFormTranslationsEN,
  anonymousAssessment: anonymousAssessmentTranslationsEN,
};
